import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

    constructor(
        private auth: AuthService,
        private router: Router
    ) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        
        if (this.auth.isLoggedIn) {
            req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + this.auth.token) });
        }

        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            }),
            catchError((err) => {

                if (err instanceof HttpErrorResponse) {

                    // 401 error that isn't the login page
                    if (err.status === 401 && this.router.url !== '/login') {
                        // not authorised? force a log out
                        this.auth.logout();
                        this.router.navigate(['/login']);
                    } else if (err.status === 403) {
                        // not allowed? do something else
                        console.log('intercepted: Not authorised');
                    } else if (err.status === 404) {
                        this.router.navigate(['/404'], { queryParams: { e: btoa(err.error) }});
                    }
                }

                return throwError(err);
            })
        );
    }
    
}
